import { useCallback, useEffect, useState } from "react";
import { Show, SignInButton, useAuth } from "@clerk/react";
import { apiFetch } from "@/lib/reels";
import { ConnectInstagram } from "@/components/reels/ConnectInstagram";
import { SavedBrowser } from "@/components/reels/SavedBrowser";

const Connected = ({ quality }) => {
  const { getToken } = useAuth();
  const [status, setStatus] = useState(null);

  const load = useCallback(async () => {
    const res = await apiFetch("/instagram/status", { token: await getToken() });
    setStatus(await res.json());
  }, [getToken]);

  useEffect(() => { load().catch(() => setStatus({ connected: false })); }, [load]);

  const disconnect = async () => {
    await apiFetch("/instagram/connect", { method: "DELETE", token: await getToken() });
    setStatus({ connected: false });
  };

  if (!status) return <div className="flex justify-center py-6"><span className="rs-spinner" /></div>;
  if (!status.connected) return <ConnectInstagram onConnected={load} />;
  return <SavedBrowser username={status.username} quality={quality} onDisconnect={disconnect} />;
};

export const SavedPanel = ({ quality }) => (
  <>
    <Show when="signed-out">
      <div className="rs-material flex flex-col items-center gap-3 p-6 text-center rs-fade" data-testid="saved-signed-out">
        <p className="text-[17px] font-semibold">Download your Saved folders</p>
        <p className="rs-secondary text-[15px]">Sign in to Recipe Remedy, link your Instagram, and save whole collections in one go.</p>
        <SignInButton><button className="rs-prominent w-full" data-testid="saved-sign-in-btn">Sign In</button></SignInButton>
      </div>
    </Show>
    <Show when="signed-in"><Connected quality={quality} /></Show>
  </>
);
